module.exports = {
  generalProgrammingData: {
    labels: ["Java", "C++", "C#", "Python"],
    datasets: [
      {
        label: "Levels",
        data: [5, 5, 5, 4],
        backgroundColor: ["#FF9933"],
      },
    ],
  },

  webDevelopmentData: {
    labels: [
      "HTML",
      "CSS/Sass",
      "JavaScript",
      "TypeScript",
      "React",
      "Angular",
      "Vue",
    ],
    datasets: [
      {
        label: "Levels",
        data: [7, 7, 7, 6, 7, 4, 3],
        backgroundColor: ["#FF9933"],
      },
    ],
  },
};
